import Vue from 'vue'
import Vuex from 'vuex'
import eventBus from '@/utils/EventBus' 
import authentication from './modules/authentication'
import devices from './modules/devices'
import telemetry from './modules/telemetry'
import apiKeys from './modules/apiKeys'
import deviceProfiles from './modules/deviceProfiles'
import map from './modules/map'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {        
        lastOperationMessage:"",
        lastOperationSuccess:false,
        operationInProcess:false,
        operationInProcessMessage: "",
        metadata:null,
        router: null,
        idsSnake: [],

        onClose : function(){
            eventBus.$emit("realtimeChannelClosed")
        },
        onMessage : function(message){
            for(let i in message.payload)
                if(message.payload[i])
                if(!message.payload[i].length || message.payload[i].length>0)
                    eventBus.$emit(i,message.payload[i])
        }
    },
    getters:{
        currentView: (state)=>{
            return state.router.history.current
        }
    },
    modules: {
        authentication,
        devices,
        telemetry,
        apiKeys,
        deviceProfiles,
        map
    },
    actions: {   
        async init({dispatch}){
            return new Promise(
                async (resolve,reject)=>{
                    try{
                        await dispatch('authentication/init')
                        await dispatch('devices/init')
                        await dispatch('apiKeys/init')
                        await dispatch('deviceProfiles/init')
                        await dispatch('telemetry/init')
                        await dispatch('map/init')

                        resolve()
                    }catch(e){
                        reject(e)
                    }
                    
                }
            )
        },

        async initUserContext({rootState, dispatch}){
            // const reopenChannelLogic = async () => {
            //     await dispatch('authentication/refresh');
            //     setTimeout(
            //         async () => await rootState.serviceModule.deviceManager.StartListenRealtimeData(
            //             reopenChannelLogic,
            //             rootState.onMessage,
            //         ),
            //         1000
            //     );
            // }

            
            let enableAppCommunication = rootState.serviceModule.deviceManager.EnableAppCommunication()
            let startListenRealtimeData = rootState.serviceModule.deviceManager.StartListenRealtimeData(
                rootState.onClose,
                rootState.onMessage,
            )
            // await reopenChannelLogic()
            
            try {
                await Promise.all([enableAppCommunication,startListenRealtimeData])
            } catch (error) {
                // Skip
            }
        },
    
        destroyUserContext({rootState,dispatch}){
             return new Promise(
                function(resolve,reject){
                    let promises = []
                    promises.push(dispatch('devices/deinit', null, {root:true}))
                    promises.push(dispatch('telemetry/deinit', null, {root:true}))
                    promises.push(dispatch('apiKeys/deinit', null, {root:true}))
                    promises.push(dispatch('deviceProfiles/deinit', null, {root:true}))
                    promises.push(rootState.serviceModule.deviceManager.StopListenRealtimeData())

                    Promise.all(promises)
                    .then((data)=>resolve(data))
                    .catch((err)=>reject(err))
                }
            )       
        },
    },
    mutations:{
        startOperation(state,message){
            state.operationInProcess=true
            state.operationInProcessMessage=message
        },
        stopOperation(state){
            setTimeout(
                ()=>{
                    state.operationInProcess=false
                    state.operationInProcessMessage=""
                },
                600
            )
        },
        successLastOperationPerformed: function(state,message){
            state.lastOperationMessage = message
            state.lastOperationSuccess = new Boolean(true)

        },
        errorLastOperationPerformed: function(state,message){
            state.lastOperationMessage = message
            state.lastOperationSuccess = new Boolean(false)

        },
        setServiceModule: function(state,serviceModule){
            state.serviceModule=serviceModule
        },
        setMetadata:function(state,metadata){
            state.metadata = metadata
        },
        setAppRouter:function(state,router){
            state.router = router
        },
        browseApp: async function(state,viewObj){
            let routeName = viewObj.name
            let query = viewObj.query
            let params = {}
            params[routeName] = viewObj.id
            
            switch(routeName){
                case "device":
                    state.idsSnake = [viewObj.id]
                    break
                case "slave":
                    state.idsSnake.push(viewObj.id) 
                    break
                default:
                    state.idsSnake = []
            }
            await state.router.push({name: routeName, params:params, query: query})
            
        }

    }
  })

export default store